import './LoadingStyles.css';

export default function LoadingSpinner({style, text = "Chargement..."}) {
        return (
            <div 
              className="loading-container"
              style={{
                height: style?.height || '100vh',
                ...style
              }}
            >
              {/* Spinner simple et élégant */}
              <div className="simple-spinner">
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
              </div>
              
              <div className="loading-text">
                {text}
              </div>
            </div>
          );
}